import { Select } from "../../SharedModule/components/Select";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import { YES_NO_OPTIONS } from "../utils/clientsUtils";
import { AllDropdownsInfo, NewClient } from "../types/clients-module-types";
import {
  SelectItem,
  SelectItemBoolean,
  SelectItemNumber,
} from "../../SharedModule/types/shared-module-types";

type ClientFormFieldsProps = {
  allUsers: any[];
  isAllUsersWithProfileLoading: boolean;
  dropdownsValues: AllDropdownsInfo | null | undefined;
  clientProfile: NewClient;
  handleChange: (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
  handleChangeDropdown: (name: string, elem: any) => void;
  currentClient: SelectItemBoolean;
  companyOwner: SelectItem | null | undefined;
  actualState: SelectItemNumber | null | undefined;
  actualCountry: SelectItemNumber | null | undefined;
  relationshipType: SelectItemNumber | null | undefined;
  industryType: SelectItemNumber | null | undefined;
  sourceType: SelectItemNumber | null | undefined;
  referredBy: SelectItemNumber | null | undefined;
  leadGenerationSourceTypeId: SelectItemNumber[] | null | undefined;
  comprehensiveCareClient: SelectItemBoolean | null | undefined;
  continuousInnovationClient: SelectItemBoolean | null | undefined;
  purchaseOrderRequired: SelectItemBoolean | null | undefined;
  useAuthorization: SelectItemBoolean | null | undefined;
  customMasterAgreement: SelectItemNumber | null | undefined;
  customNda: SelectItemNumber | null | undefined;
  billingCycle: SelectItemNumber | null | undefined;
  invoiceFormat: SelectItemNumber | null | undefined;
  billingTerm: SelectItemNumber | null | undefined;
  taxable: SelectItemBoolean | null | undefined;
  taxJurisdiction: SelectItemNumber | null | undefined;
  priceScheduleInputStyle?: React.CSSProperties;
  submitButton: React.ReactNode;
};

export const ClientFormFields = ({
  allUsers,
  isAllUsersWithProfileLoading,
  dropdownsValues,
  clientProfile,
  handleChange,
  handleChangeDropdown,
  currentClient,
  companyOwner,
  actualState,
  actualCountry,
  relationshipType,
  industryType,
  sourceType,
  referredBy,
  leadGenerationSourceTypeId,
  comprehensiveCareClient,
  continuousInnovationClient,
  purchaseOrderRequired,
  useAuthorization,
  customMasterAgreement,
  customNda,
  billingCycle,
  invoiceFormat,
  billingTerm,
  taxable,
  taxJurisdiction,
  priceScheduleInputStyle,
  submitButton,
}: ClientFormFieldsProps) => {
  return (
    <>
      <div
        className="d-flex justify-content-between"
        style={{ margin: "1% 8%" }}
      >
        <h3 style={{ marginTop: "0.5rem" }}>Client Information</h3>
      </div>

      <div className="row" style={{ margin: "0 8%" }}>
        <div className="d-flex p-0 mb-3">
          <div className="flex-column w-50 me-5">
            <label className="col-form-label" htmlFor="clientNameInput">
              Client Name *
            </label>
            <input
              id="clientNameInput"
              type="text"
              className="form-control form-control-sm common-input"
              value={clientProfile.companyName}
              name="companyName"
              onChange={handleChange}
              disabled={false}
            />
          </div>
          <div className="flex-column w-50 ms-5">
            <label className="col-form-label" htmlFor="clientAliasNameInput">
              Client Alias Name
            </label>
            <input
              id="clientAliasNameInput"
              type="text"
              className="form-control form-control-sm common-input"
              value={clientProfile.companyAliasName ?? ""}
              name="companyAliasName"
              onChange={handleChange}
              disabled={false}
            />
          </div>
        </div>

        <div className="d-flex p-0 mb-3">
          <div className="flex-column w-50 me-5">
            <label className="col-form-label" htmlFor="clientOwnerSelect">
              Client Owner *
            </label>
            <Select
              id="clientOwnerSelect"
              className="common-input"
              options={allUsers}
              value={companyOwner}
              placeholder={"Please select a client owner"}
              onChange={(owner) =>
                handleChangeDropdown("companyOwnerUserId", owner)
              }
              isDisabled={isAllUsersWithProfileLoading}
            />
          </div>
          <div className="flex-column w-50 ms-5">
            <label className="col-form-label" htmlFor="isClientSelect">
              Is Client? *
            </label>
            <Select
              placeholder={"Please select"}
              id="isClientSelect"
              className="common-input"
              options={YES_NO_OPTIONS}
              value={currentClient}
              onChange={() => {}}
              isDisabled={true}
            />
          </div>
        </div>

        <div className="d-flex p-0 mb-3">
          <div className="flex-column w-50 me-5">
            <label className="col-form-label" htmlFor="streetAddressInput">
              Street Address *
            </label>
            <input
              id="streetAddressInput"
              type="text"
              className="form-control form-control-sm common-input"
              value={clientProfile.streetAddress}
              name="streetAddress"
              onChange={handleChange}
              disabled={true}
            />
          </div>
          <div className="flex-column w-50 ms-5">
            <label className="col-form-label" htmlFor="streetAddress2Input">
              Street Address 2
            </label>
            <input
              id="streetAddress2Input"
              type="text"
              className="form-control form-control-sm common-input"
              value={clientProfile.streetAddress2 ?? ""}
              name="streetAddress2"
              onChange={handleChange}
              disabled={false}
            />
          </div>
        </div>

        <div className="d-flex p-0 mb-3">
          <div className="flex-column w-50 me-5">
            <label className="col-form-label" htmlFor="cityInput">
              City *
            </label>
            <input
              id="cityInput"
              type="text"
              className="form-control form-control-sm common-input"
              value={clientProfile.city}
              name="city"
              onChange={handleChange}
              disabled={true}
            />
          </div>
          <div className="flex-column w-50 ms-5">
            <label className="col-form-label" htmlFor="stateSelect">
              State *
            </label>
            <Select
              placeholder={"Please select"}
              id="stateSelect"
              className="common-input"
              options={dropdownsValues?.states}
              value={actualState}
              isDisabled={true}
              onChange={() => {}}
            />
          </div>
        </div>

        <div className="d-flex p-0 mb-3">
          <div className="flex-column w-50 me-5">
            <label className="col-form-label" htmlFor="postalCodeInput">
              Postal Code *
            </label>
            <input
              id="postalCodeInput"
              type="text"
              className="form-control form-control-sm common-input"
              value={clientProfile.postalCode}
              name="postalCode"
              onChange={handleChange}
              disabled={true}
            />
          </div>
          <div className="flex-column w-50 ms-5">
            <label className="col-form-label" htmlFor="countrySelect">
              Country *
            </label>
            <Select
              placeholder={"Please select"}
              id="countrySelect"
              className="common-input"
              options={dropdownsValues?.countries}
              value={actualCountry}
              isDisabled={true}
              onChange={() => {}}
            />
          </div>
        </div>

        <div className="d-flex p-0 mb-3">
          <div className="flex-column w-50 me-5">
            <label className="col-form-label" htmlFor="phoneNumberInput">
              Phone Number
            </label>
            <input
              id="phoneNumberInput"
              type="text"
              className="form-control form-control-sm common-input"
              value={clientProfile.phoneNumber ?? ""}
              name="phoneNumber"
              onChange={handleChange}
              disabled={false}
            />
          </div>
          <div className="flex-column w-50 ms-5">
            <label className="col-form-label" htmlFor="websiteUrlInput">
              Website URL
            </label>
            <input
              id="websiteUrlInput"
              type="text"
              className="form-control form-control-sm common-input"
              value={clientProfile.websiteUrl ?? ""}
              name="websiteUrl"
              onChange={handleChange}
              disabled={false}
            />
          </div>
        </div>

        <div className="d-flex p-0 mb-3">
          <div className="flex-column w-50 me-5">
            <label
              className="col-form-label"
              htmlFor="companyDomainNameInput"
            >
              Company Domain Name
            </label>
            <input
              id="companyDomainNameInput"
              type="text"
              className="form-control form-control-sm common-input"
              value={clientProfile.companyDomainName ?? ""}
              name="companyDomainName"
              onChange={handleChange}
              disabled={false}
            />
          </div>
          <div className="flex-column w-50 ms-5">
            <label className="col-form-label" htmlFor="priceScheduleInput">
              Price Schedule *
            </label>
            <input
              id="priceScheduleInput"
              type="number"
              min={0}
              onKeyDown={(e) => {
                if (
                  e.key === "e" ||
                  e.key === "E" ||
                  e.key === "+" ||
                  e.key === "-"
                ) {
                  e.preventDefault();
                }
              }}
              className="form-control form-control-sm common-input"
              value={clientProfile.priceSchedule}
              name="priceSchedule"
              onChange={handleChange}
              disabled={true}
              style={priceScheduleInputStyle}
            />
          </div>
        </div>

        <div className="d-flex p-0 mb-3">
          <div className="flex-column w-50 me-5">
            <label
              className="col-form-label"
              htmlFor="relationshipTypeSelect"
            >
              Relationship *
            </label>
            <Select
              placeholder={"Please select"}
              id="relationshipTypeSelect"
              className="common-input"
              options={dropdownsValues?.relationshipTypes}
              value={relationshipType}
              isDisabled={true}
              onChange={() => {}}
            />
          </div>
          <div className="flex-column w-50 ms-5">
            <label className="col-form-label" htmlFor="industryTypeSelect">
              Industry *
            </label>
            <Select
              placeholder={"Please select"}
              id="industryTypeSelect"
              className="common-input"
              options={dropdownsValues?.industryTypes}
              value={industryType}
              isDisabled={true}
              onChange={() => {}}
            />
          </div>
        </div>

        <div className="d-flex p-0 mb-3">
          <div className="flex-column w-50 me-5">
            <label className="col-form-label" htmlFor="sourceTypeSelect">
              Original Source *
            </label>
            <Select
              placeholder={"Please select"}
              id="sourceTypeSelect"
              className="common-input"
              options={dropdownsValues?.sourceTypes}
              value={sourceType}
              isDisabled={true}
              onChange={() => {}}
            />
          </div>
          <div className="flex-column w-50 ms-5">
            <label className="col-form-label" htmlFor="referredByInput">
              Referred By
            </label>
            <Select
              placeholder={"Please select"}
              id="referredByInput"
              className="common-input"
              options={dropdownsValues?.referralTypes}
              value={referredBy}
              isDisabled={true}
              onChange={() => {}}
            />
          </div>
        </div>

        <div className="d-flex p-0 mb-3">
          <div className="flex-column w-50 me-5">
            <label
              className="col-form-label"
              htmlFor="leadGenerationSourceTypeSelect"
            >
              Lead Generation Source
            </label>
            <Select
              id="leadGenerationSourceTypeSelect"
              isMulti
              className="common-input"
              options={dropdownsValues?.leadGenerationSourceTypes}
              value={leadGenerationSourceTypeId}
              placeholder={"Please select"}
              onChange={(lgs) =>
                handleChangeDropdown("leadGenerationSourceTypeId", lgs)
              }
            />
          </div>
          <div className="flex-column w-50 ms-5">
            <label
              className="col-form-label"
              htmlFor="comprehensiveCareClientSelect"
            >
              Comprehensive Care Client
            </label>
            <Select
              id="comprehensiveCareClientSelect"
              className="common-input"
              options={YES_NO_OPTIONS}
              value={comprehensiveCareClient}
              placeholder={"Please select"}
              onChange={(ccc) =>
                handleChangeDropdown("comprehensiveCareClient", ccc)
              }
            />
          </div>
        </div>

        <div className="d-flex p-0 mb-3">
          <div className="flex-column w-50 me-5">
            <label
              className="col-form-label"
              htmlFor="continuousInnovationClientSelect"
            >
              Continuous Innovation Client
            </label>
            <Select
              id="continuousInnovationClientSelect"
              className="common-input"
              options={YES_NO_OPTIONS}
              value={continuousInnovationClient}
              placeholder={"Please select"}
              onChange={(cic) =>
                handleChangeDropdown("continuousInnovationClient", cic)
              }
            />
          </div>
          <div className="flex-column w-50 ms-5">
            <label
              className="col-form-label"
              htmlFor="purchaseOrderRequiredSelect"
            >
              Purchase Order Required
            </label>
            <Select
              id="purchaseOrderRequiredSelect"
              className="common-input"
              options={YES_NO_OPTIONS}
              value={purchaseOrderRequired}
              placeholder={"Please select"}
              onChange={(por) =>
                handleChangeDropdown("purchaseOrderRequired", por)
              }
            />
          </div>
        </div>

        <div className="d-flex p-0 mb-3">
          <div className="flex-column w-50 me-5">
            <label
              className="col-form-label"
              htmlFor="useAuthorizationSelect"
            >
              Use Authorization
            </label>
            <Select
              id="useAuthorizationSelect"
              className="common-input"
              options={YES_NO_OPTIONS}
              value={useAuthorization}
              placeholder={"Please select"}
              onChange={(use) =>
                handleChangeDropdown("useAuthorization", use)
              }
            />
          </div>
          <div className="flex-column w-50 ms-5">
            <label
              className="col-form-label"
              htmlFor="customMasterAgreementInput"
            >
              Custom Master Agreement
            </label>
            <Select
              placeholder={"Please select"}
              id="customMasterAgreementInput"
              className="common-input"
              options={dropdownsValues?.customMasterAgreements}
              value={customMasterAgreement}
              onChange={(agreement) =>
                handleChangeDropdown("customMasterAgreementId", agreement)
              }
            />
          </div>
        </div>

        <div className="d-flex p-0 mb-3">
          <div className="flex-column w-50 me-5">
            <label className="col-form-label" htmlFor="customNdaSelect">
              Custom NDA
            </label>
            <Select
              id="customNdaSelect"
              className="common-input"
              options={dropdownsValues?.customNdas}
              value={customNda}
              placeholder={"Please select"}
              onChange={(nda) => handleChangeDropdown("customNda", nda)}
            />
          </div>
          <div className="flex-column w-50 ms-5">
            <label
              className="col-form-label"
              htmlFor="legalInformationLocationInput"
            >
              Legal Information Location
            </label>
            <input
              id="legalInformationLocationInput"
              type="text"
              className="form-control form-control-sm common-input"
              value={clientProfile.legalInformationLocation ?? ""}
              name="legalInformationLocation"
              onChange={handleChange}
              disabled={false}
            />
          </div>
        </div>

        <div className="d-flex p-0 mb-3">
          <div className="flex-column w-100">
            <label className="col-form-label" htmlFor="legalNotesTextarea">
              Legal Notes
            </label>
            <TextareaAutosize
              id="legalNotesTextarea"
              minRows={1}
              maxRows={5}
              className="textarea-resize w-100 d-flex common-input"
              value={clientProfile.legalNotes ?? ""}
              name="legalNotes"
              onChange={handleChange}
              disabled={false}
              style={{ height: "100px", resize: "none" }}
            />
          </div>
        </div>

        <h3 style={{ padding: "0", margin: "1% 0" }}>Billing Information</h3>

        <div className="d-flex p-0 mb-3">
          <div className="flex-column w-50 me-5">
            <label className="col-form-label" htmlFor="billingCycleSelect">
              Billing Cycle *
            </label>
            <Select
              placeholder={"Please select"}
              id="billingCycleSelect"
              className="common-input"
              options={dropdownsValues?.billingCycles}
              value={billingCycle}
              isDisabled={true}
              onChange={() => {}}
            />
          </div>
          <div className="flex-column w-50 ms-5">
            <label className="col-form-label" htmlFor="invoiceFormatSelect">
              Invoice Format *
            </label>
            <Select
              id="invoiceFormatSelect"
              className="common-input"
              options={dropdownsValues?.invoiceFormats}
              value={invoiceFormat}
              placeholder={"Please select"}
              onChange={(invoice) =>
                handleChangeDropdown("invoiceFormatId", invoice)
              }
            />
          </div>
        </div>

        <div className="d-flex p-0 mb-3">
          <div className="flex-column w-50 me-5">
            <label className="col-form-label" htmlFor="billingTermSelect">
              Terms *
            </label>
            <Select
              placeholder={"Please select"}
              id="billingTermSelect"
              className="common-input"
              options={dropdownsValues?.billingTerms}
              value={billingTerm}
              isDisabled={true}
              onChange={() => {}}
            />
          </div>
          <div className="flex-column w-50 ms-5">
            <label className="col-form-label" htmlFor="taxableSelect">
              Taxable *
            </label>
            <Select
              placeholder={"Please select"}
              id="taxableSelect"
              className="common-input"
              options={YES_NO_OPTIONS}
              value={taxable}
              isDisabled={true}
              onChange={() => {}}
            />
          </div>
        </div>

        <div className="d-flex p-0 mb-3">
          <div className="flex-column w-50 me-5">
            <label
              className="col-form-label"
              htmlFor="taxJurisdictionSelect"
            >
              Tax Jurisdictions *
            </label>
            <Select
              placeholder={"Please select"}
              id="taxJurisdictionSelect"
              className="common-input"
              options={dropdownsValues?.taxJurisdictions}
              value={taxJurisdiction}
              isDisabled={true}
              onChange={() => {}}
            />
          </div>
          <div className="flex-column w-50 ms-5"></div>
        </div>

        <div className="d-flex p-0 mb-5">
          <div className="flex-column w-100">
            <label
              className="col-form-label"
              htmlFor="accountingNotesTextarea"
            >
              Accounting Notes
            </label>
            <TextareaAutosize
              id="accountingNotesTextarea"
              minRows={1}
              maxRows={5}
              className="textarea-resize w-100 d-flex common-input"
              value={clientProfile.accountingNotes ?? ""}
              name="accountingNotes"
              onChange={handleChange}
              disabled={false}
              style={{ height: "100px", resize: "none" }}
            />
          </div>
        </div>

        {submitButton}
      </div>
    </>
  );
};
